<template>
  <div class="whats-new-wrapper">
    <p class="title-text">
      <span class="title-text">What's New</span>
      <span class="view-more" @click="$router.push('/new-arrival?source=homePage|mainIcon|whatsNew&first_page=home')">View More</span>
    </p>

    <div class="skus">
      <div class="sku-item" v-for="(item, idx) in newArrival" :key="idx">
        <PCProductItemCard type="whats-new" :product-data="item" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { newArrival as getNewArrival } from '@/api/models/system'
import { buildWhatsNewRecommendSource } from '@/plugins/utils'

const emit = defineEmits<{ (e: 'hidden'): void }>()

const NEW_ARRIVAL_CACHE_TTL = 5 * 60 * 1000
const newArrival = ref<any[]>(new Array(6).fill({
    "listingId": -1,
    "minPrice": 0,
    "image": ""
}))
const initNewArrival = async () => {
  let localNewArrival: { cachedAt: number; data: any[] } | null = null

  try {
    localNewArrival = JSON.parse(localStorage.getItem('pc__home_newarrival') || 'null')
  } catch(e) {
    console.error('PC 首页新品缓存解析失败:', e)
  }

  const cacheAge = Date.now() - Number(localNewArrival?.cachedAt || 0)
  const isCacheValid = Array.isArray(localNewArrival?.data)
    && cacheAge >= 0
    && cacheAge < NEW_ARRIVAL_CACHE_TTL

  if(!isCacheValid) {
    const res = await getNewArrival({ limit: 6, lastId: -1 }, false)

    newArrival.value = (res.listings || []).map((c: any) => {
      c.source = buildWhatsNewRecommendSource(c.modelName || c.algorithmModelName || '', 'home')

      return c
    })

    localStorage.setItem('pc__home_newarrival', JSON.stringify({
      cachedAt: Date.now(),
      data: newArrival.value
    }))
  } else {
    newArrival.value = localNewArrival!.data
  }

  newArrival.value.length <= 0 && emit('hidden')
}

onMounted(() => {
  initNewArrival()
})
</script>

<style lang="scss" scoped>
.whats-new-wrapper {
  height: 530px;
}
// @media (max-width: 1800px) {
//   .whats-new-wrapper {
//     height: 460px;
//   }
// }
.title-text{
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  .title-text{
    font-size: 42px;
    font-weight: 600;
  }
  .view-more{
    cursor: pointer;
    user-select: none;
    color: #666;
    transition: color .15s;
    font-size: 400;
    &:hover{
      color: var(--pc-default-color);
    }
  }
}
.skus{
  display: flex;
  flex-wrap: nowrap;
  .sku-item{
    width: 20%;
    padding: 10px;
    box-sizing: border-box;
  }
}
</style>